export default __webpack_public_path__ + "static/media/Homepage2.3c08bdc5.png";